export default {
  index: [
    {
      path: '/fwcommodity',
      component: resolve => require(['./fwcommodityIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/fwcommodity/_router.js